/**
 * shop-checkout.js — FlorixSports Checkout Page
 * ─────────────────────────────────────────────────────
 * 1. Multi-step form (Delivery → Payment → Review)
 * 2. Stepper indicator updates
 * 3. Basic field validation per step
 * 4. Card number / expiry input auto-formatting
 * 5. Delivery info saved to cart note via AJAX (shows in Shopify admin)
 * 6. "Place Order" → redirects to Shopify's /checkout
 */

(function () {
  'use strict';

  var page = document.getElementById('shopCheckoutPage');
  if (!page) return;

  /* ──────────────────────────────────────────────
     State
     ────────────────────────────────────────────── */
  var currentStep = 0;

  var form = {
    email:      '',
    firstName:  '',
    lastName:   '',
    address:    '',
    city:       '',
    postcode:   '',
    country:    'GB',
  };

  /* ──────────────────────────────────────────────
     DOM references
     ────────────────────────────────────────────── */
  var panels  = page.querySelectorAll('.shop-co__panel');
  var steps   = page.querySelectorAll('.shop-co__step');

  var fields = {
    email:      document.getElementById('co-email'),
    firstName:  document.getElementById('co-first-name'),
    lastName:   document.getElementById('co-last-name'),
    address:    document.getElementById('co-address'),
    city:       document.getElementById('co-city'),
    postcode:   document.getElementById('co-postcode'),
    country:    document.getElementById('co-country'),
    cardNumber: document.getElementById('co-card-number'),
    expiry:     document.getElementById('co-expiry'),
    cvv:        document.getElementById('co-cvv'),
    nameOnCard: document.getElementById('co-name-on-card'),
  };

  /* ──────────────────────────────────────────────
     Step management
     ────────────────────────────────────────────── */
  function goToStep(n) {
    /* Update panels */
    panels.forEach(function (p, i) {
      p.classList.toggle('is-active', i === n);
    });

    /* Update stepper dots */
    steps.forEach(function (s, i) {
      s.classList.remove('is-active', 'is-done');
      if (i === n) {
        s.classList.add('is-active');
        s.setAttribute('aria-current', 'step');
      } else if (i < n) {
        s.classList.add('is-done');
        s.removeAttribute('aria-current');
        s.querySelector('.shop-co__step-dot').textContent = '✓';
      } else {
        s.removeAttribute('aria-current');
        s.querySelector('.shop-co__step-dot').textContent = i + 1;
      }
    });

    /* Scroll to top of form */
    var card = panels[n];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    currentStep = n;

    /* Populate review when arriving at step 2 */
    if (n === 2) populateReview();
  }

  /* ──────────────────────────────────────────────
     Validation helpers
     ────────────────────────────────────────────── */
  function markInvalid(el) {
    if (el) el.classList.add('is-invalid');
  }

  function clearInvalid(el) {
    if (el) el.classList.remove('is-invalid');
  }

  function validateStep0() {
    var ok = true;
    var required = ['email', 'firstName', 'lastName', 'address', 'city', 'postcode'];
    required.forEach(function (key) {
      var el = fields[key];
      if (!el) return;
      var val = el.value.trim();
      if (!val) { markInvalid(el); ok = false; }
      else clearInvalid(el);
    });
    /* Basic email format check */
    if (fields.email && fields.email.value && !fields.email.value.includes('@')) {
      markInvalid(fields.email);
      ok = false;
    }
    return ok;
  }

  /* ──────────────────────────────────────────────
     Read form values into state
     ────────────────────────────────────────────── */
  function readDeliveryForm() {
    form.email     = (fields.email     && fields.email.value.trim())     || '';
    form.firstName = (fields.firstName && fields.firstName.value.trim()) || '';
    form.lastName  = (fields.lastName  && fields.lastName.value.trim())  || '';
    form.address   = (fields.address   && fields.address.value.trim())   || '';
    form.city      = (fields.city      && fields.city.value.trim())      || '';
    form.postcode  = (fields.postcode  && fields.postcode.value.trim())  || '';
    form.country   = (fields.country   && fields.country.value)          || 'GB';
  }

  /* ──────────────────────────────────────────────
     Populate review step (step 2)
     ────────────────────────────────────────────── */
  function formatMoney(pence) {
    return '\u00a3' + (pence / 100).toFixed(2);
  }

  function populateReview() {
    /* Item list */
    var itemsEl = document.getElementById('shopCoReviewItems');
    if (itemsEl && window.shopCheckoutCart) {
      var html = '';
      window.shopCheckoutCart.items.forEach(function (item) {
        var thumbHtml = item.image
          ? '<img class="shop-co__review-thumb" src="' + item.image + '" alt="' + escHtml(item.imageAlt) + '" width="48" height="56" loading="lazy">'
          : '<div class="shop-co__review-thumb--placeholder"></div>';

        var metaParts = [];
        if (item.variant && item.variant !== 'Default Title') metaParts.push('Size: ' + item.variant);
        metaParts.push('Qty: ' + item.quantity);

        html += '<div class="shop-co__review-item">'
          + thumbHtml
          + '<div class="shop-co__review-item-info">'
          +   '<p class="shop-co__review-item-name">' + escHtml(item.title) + '</p>'
          +   '<p class="shop-co__review-item-meta">' + metaParts.join(' · ') + '</p>'
          + '</div>'
          + '<span class="shop-co__review-item-price">' + formatMoney(item.linePrice) + '</span>'
          + '</div>';
      });
      itemsEl.innerHTML = html;
    }

    /* Delivery confirm box */
    var delivEl = document.getElementById('shopCoDeliveryConfirm');
    if (delivEl) {
      if (form.firstName) {
        delivEl.innerHTML =
          '<strong>Delivering to:</strong>'
          + escHtml(form.firstName) + ' ' + escHtml(form.lastName) + ', '
          + escHtml(form.address) + ', '
          + escHtml(form.city) + ' '
          + escHtml(form.postcode);
      } else {
        delivEl.style.display = 'none';
      }
    }
  }

  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ──────────────────────────────────────────────
     Save delivery info to cart note (AJAX)
     Appears in Shopify admin under the order
     ────────────────────────────────────────────── */
  function saveCartNote() {
    var note = [
      'Contact: ' + form.email,
      'Name: ' + form.firstName + ' ' + form.lastName,
      'Address: ' + form.address + ', ' + form.city + ', ' + form.postcode + ', ' + form.country,
    ].join('\n');

    return fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ note: note }),
    })
    .catch(function (err) {
      console.warn('[shop-checkout] Could not save cart note:', err);
    });
  }

  /* ──────────────────────────────────────────────
     Button handlers
     ────────────────────────────────────────────── */

  /* Step 0 → 1 */
  var next0 = document.getElementById('shopCoNext0');
  if (next0) {
    next0.addEventListener('click', function () {
      if (!validateStep0()) return;
      readDeliveryForm();
      goToStep(1);
    });
  }

  /* Step 1 back → 0 */
  var back1 = document.getElementById('shopCoBack1');
  if (back1) { back1.addEventListener('click', function () { goToStep(0); }); }

  /* Step 1 → 2 */
  var next1 = document.getElementById('shopCoNext1');
  if (next1) { next1.addEventListener('click', function () { goToStep(2); }); }

  /* Step 2 back → 1 */
  var back2 = document.getElementById('shopCoBack2');
  if (back2) { back2.addEventListener('click', function () { goToStep(1); }); }

  /* Place Order → save note + redirect to Shopify checkout */
  var placeOrder = document.getElementById('shopCoPlaceOrder');
  if (placeOrder) {
    placeOrder.addEventListener('click', function () {
      placeOrder.classList.add('is-loading');
      placeOrder.querySelector('.shop-co__place-order-label').textContent = 'Processing\u2026';

      saveCartNote().then(function () {
        window.location.href = '/checkout';
      });
    });
  }

  /* ──────────────────────────────────────────────
     Input auto-formatting
     ────────────────────────────────────────────── */

  /* Card number: insert spaces every 4 digits */
  if (fields.cardNumber) {
    fields.cardNumber.addEventListener('input', function () {
      var raw   = this.value.replace(/\D/g, '').slice(0, 16);
      var formatted = raw.replace(/(.{4})/g, '$1 ').trim();
      this.value = formatted;
    });
  }

  /* Expiry: MM / YY format */
  if (fields.expiry) {
    fields.expiry.addEventListener('input', function (e) {
      var raw = this.value.replace(/\D/g, '').slice(0, 4);
      if (raw.length >= 3) {
        this.value = raw.slice(0, 2) + ' / ' + raw.slice(2);
      } else {
        this.value = raw;
      }
    });
  }

  /* CVV: digits only */
  if (fields.cvv) {
    fields.cvv.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 4);
    });
  }

  /* Clear invalid on input */
  Object.keys(fields).forEach(function (key) {
    var el = fields[key];
    if (el) {
      el.addEventListener('input', function () { clearInvalid(el); });
    }
  });

  /* ──────────────────────────────────────────────
     Initialise at step 0
     ────────────────────────────────────────────── */
  goToStep(0);

})();
